module.exports = __webpack_public_path__ + "static/about_preview.d6af0fc3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Hero/navigation/about_preview.jpg
// module id = 685
// module chunks = 213534597649335